import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2426d31a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top" }
const _hoisted_2 = {
  key: 0,
  class: "date"
}
const _hoisted_3 = { class: "datepickerLabel" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "date"
}
const _hoisted_6 = { class: "datepickerLabel" }

import { ref } from 'vue';
import { INFO_CARD_COLOR } from '@constants/info-card-color';
import { timetableBackupUrl } from '../../envVariables';
import { Button } from '../../Atoms';
import {
  TimetableSearchResults,
  TimetableSearchInput,
  InteractiveMapLink,
  DatePickerCalendar,
  InfoCard,
} from '../../Molecules';
import { Sailing } from '../../types/Sailing';
import { useTimetableStore } from '../../stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'TimetableSearch',
  props: {
    from: {},
    to: {},
    mapLink: {},
    initialDate: {},
    toInputLabel: {},
    fromInputLabel: {},
    fromPlaceholder: {},
    toPlaceholder: {},
    datePickerLabel: {},
    todayText: {},
    buttonText: {},
    displayResults: { type: Boolean },
    disabled: { type: Boolean },
    isBannerView: { type: Boolean },
    datepickerTeleportId: {},
    isIonicApp: { type: Boolean }
  },
  emits: ['timetableSearchClick'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const timetableStore = useTimetableStore();

const emit = __emit;

const fromInput = ref<string>();
const toInput = ref<string>();
const dateInput = ref<string>(props.initialDate);
const routeCode = ref<string>('');
const timetableSearchResults = ref<Sailing[]>();

const handleSearch = (
  originPortName: string | undefined,
  destinationPortName: string | undefined,
  sailingDate: string,
  selectedRouteCode: string,
) => {
  const from = originPortName ?? props.from;
  const to = destinationPortName ?? props.to;
  const code = selectedRouteCode ?? routeCode.value;

  emit('timetableSearchClick', from, to, sailingDate, code);
};

const onDateSelected = (date) => {
  dateInput.value = date;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["timetableSearch", { disabled:_ctx.disabled, bannerView: _ctx.isBannerView }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(TimetableSearchInput), {
        from: _ctx.from,
        "from-label": _ctx.fromInputLabel ? _ctx.fromInputLabel : _ctx.$t('From'),
        "from-placeholder": _ctx.fromPlaceholder ? _ctx.fromPlaceholder : _ctx.$t('Timetable search placeholder'),
        to: _ctx.to,
        "to-label": _ctx.toInputLabel ? _ctx.toInputLabel : _ctx.$t('To'),
        "to-placeholder": _ctx.toPlaceholder ? _ctx.toPlaceholder : _ctx.$t('Timetable search placeholder'),
        error: false,
        disabled: _ctx.disabled,
        onUpdateFrom: _cache[0] || (_cache[0] = (value) => (fromInput.value = value)),
        onUpdateTo: _cache[1] || (_cache[1] = (value) => (toInput.value = value)),
        onUpdateRouteCode: _cache[2] || (_cache[2] = (value) => (routeCode.value = value))
      }, null, 8, ["from", "from-label", "from-placeholder", "to", "to-label", "to-placeholder", "disabled"]),
      (_ctx.isBannerView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.datePickerLabel ? _ctx.datePickerLabel : _ctx.$t("Outbound date")), 1),
            _createVNode(_unref(DatePickerCalendar), {
              "date-format": 'dd/MM/yyyy',
              disabled: _ctx.disabled,
              "initial-date": _ctx.initialDate,
              "today-text": _ctx.todayText ? _ctx.todayText : _ctx.$t('Today'),
              "onUpdate:selectedDate": onDateSelected
            }, null, 8, ["disabled", "initial-date", "today-text"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.mapLink && !_ctx.isBannerView)
      ? (_openBlock(), _createBlock(_unref(InteractiveMapLink), {
          key: 0,
          icon: "mapIcon",
          link: _ctx.mapLink
        }, null, 8, ["link"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (!_ctx.isBannerView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.datePickerLabel ? _ctx.datePickerLabel : _ctx.$t("Outbound date")), 1),
            _createVNode(_unref(DatePickerCalendar), {
              "teleport-id": _ctx.datepickerTeleportId,
              "date-format": 'dd/MM/yyyy',
              disabled: _ctx.disabled,
              "initial-date": _ctx.initialDate,
              "today-text": _ctx.todayText ? _ctx.todayText : _ctx.$t('Today'),
              "onUpdate:selectedDate": onDateSelected
            }, null, 8, ["teleport-id", "disabled", "initial-date", "today-text"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.mapLink && _ctx.isBannerView)
        ? (_openBlock(), _createBlock(_unref(InteractiveMapLink), {
            key: 1,
            icon: "mapIcon",
            link: _ctx.mapLink
          }, null, 8, ["link"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(Button), {
        label: _ctx.buttonText,
        secondary: true,
        "on-click": ()=>handleSearch(fromInput.value, toInput.value, dateInput.value, routeCode.value),
        disabled: _ctx.disabled
      }, null, 8, ["label", "on-click", "disabled"])
    ]),
    (timetableSearchResults.value && _ctx.displayResults)
      ? (_openBlock(), _createBlock(_unref(timetableSearchResults), {
          key: 1,
          sailings: timetableSearchResults.value,
          "is-loading": _unref(timetableStore).isLoading,
          "is-error": _unref(timetableStore).isServerError
        }, null, 8, ["sailings", "is-loading", "is-error"]))
      : _createCommentVNode("", true),
    (_unref(timetableStore).isServerError)
      ? (_openBlock(), _createBlock(_unref(InfoCard), {
          key: 2,
          "icon-name": "warning",
          text: _ctx.$t('Trouble retrieving timetables'),
          "embedded-link": _unref(timetableBackupUrl),
          "embedded-link-text": 'here.',
          lg: true,
          "background-color": _unref(INFO_CARD_COLOR).white,
          "border-color": _unref(INFO_CARD_COLOR).red
        }, null, 8, ["text", "embedded-link", "background-color", "border-color"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})